module.exports = __webpack_public_path__ + "img/mastercard.f7d4786a.svg";